import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, get, patch, post, put } from "helpers/api_helper"
import {
  GET_CATERING_LIST,
  ADD_CATERING,
  EDIT_DELETE_CATERING,
  GET_ROASTER_CATERING,
  ADD_ROASTER_CATERING,
  UPDATE_ROASTER_CATERING,
  DELETE_ROASTER_CATERING,
} from "helpers/url_helper"

export const getAllCaterings = createAsyncThunk(
  GET_CATERING_LIST,
  async payload => {
    const response = await post(GET_CATERING_LIST, payload)
    return response
  }
)

export const getCateringListRoaster = createAsyncThunk(
  GET_ROASTER_CATERING + "roaster",
  async payload => {
    const response = await post(GET_ROASTER_CATERING, payload)
    return response
  }
)

export const addCatering = createAsyncThunk(ADD_CATERING, async payload => {
  const response = await post(ADD_CATERING, payload)
  return response
})

export const addRoasterCatering = createAsyncThunk(
  ADD_ROASTER_CATERING,
  async payload => {
    const response = await post(ADD_ROASTER_CATERING, payload)
    return response
  }
)
export const updateRoasterCatering = createAsyncThunk(
  UPDATE_ROASTER_CATERING,
  async payload => {
    const response = await put(
      `${UPDATE_ROASTER_CATERING}/${payload.id}`,
      payload.data
    )
    return response
  }
)

export const updateCatering = createAsyncThunk(
  EDIT_DELETE_CATERING,
  async data => {
    const { uuid, payload } = data

    const response = await put(`${EDIT_DELETE_CATERING}/${uuid}`, payload)
    return response
  }
)

export const deleteCatering = createAsyncThunk(
  EDIT_DELETE_CATERING + "DELETE",
  async uuid => {
    const response = await del(`${EDIT_DELETE_CATERING}/${uuid}`)
    return response
  }
)
export const deleteRoasterCatering = createAsyncThunk(
  DELETE_ROASTER_CATERING + "DELETE",
  async uuid => {
    const response = await del(`${DELETE_ROASTER_CATERING}/${uuid}`)
    return response
  }
)
